import { Injectable, inject } from '@angular/core';
import {
  BaseWebsocketMessage,
  SubWebsocketMessageRequest,
  WSEntityManager,
  WebSocketService,
  WebsocketEntTypes,
} from '@qtek/core/websockets-core';
import { NoteWriteValue } from '@qtek/shared/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NoteUserService {
  private websocketService = inject(WebSocketService);

  entityName: WebsocketEntTypes = 'Note';
  wsManager = new WSEntityManager(this.websocketService, this.entityName);

  subscribe(
    payload: Omit<SubWebsocketMessageRequest, 'ent' | 'op'>
  ): Observable<BaseWebsocketMessage> {
    return this.wsManager.subscribeEntity(payload, true);
  }

  createNote(note: NoteWriteValue, refId: string, mysid: string) {
    const item = refId?.replace('itm=', '') || undefined;
    this.wsManager.create({
      res: { ...note, ...(item ? { item } : {}) },
      mysid,
    });
  }

  updateNote(note: NoteWriteValue, mysid: string) {
    this.wsManager.update({ res: note, id: note._id, mysid });
  }

  deleteNote(id: string, mysid: string) {
    this.wsManager.delete({ id, mysid });
  }
}
